import React, { useState } from 'react';
import { FileUpload } from '../../ui/FileUpload';
import { Button } from '../../ui/Button';
import { ArrowRight, ArrowLeft } from 'lucide-react';
interface AddressProofScreenProps {
  onNext: (file: File) => void;
  onBack: () => void;
  initialFile?: File | null;
}
export function AddressProofScreen({
  onNext,
  onBack,
  initialFile
}: AddressProofScreenProps) {
  const [file, setFile] = useState<File | null>(initialFile || null);
  return <div className="flex flex-col h-full animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-44">
      <div className="flex-1" data-id="element-45">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-46">
          Proof of Address
        </h2>
        <p className="text-gray-600 mb-8" data-id="element-47">
          Upload a recent utility bill, bank statement, or tax document (dated
          within the last 3 months).
        </p>

        <div className="max-w-xl" data-id="element-48">
          <FileUpload label="Address Proof Document" accept=".pdf,.jpg,.jpeg,.png" onChange={file => setFile(file)} value={file} data-id="element-49" />
        </div>
      </div>

      <div className="mt-8 flex justify-between items-center" data-id="element-50">
        <Button variant="secondary" onClick={onBack} data-id="element-51">
          <ArrowLeft className="mr-2 h-4 w-4" data-id="element-52" /> Back
        </Button>
        <Button onClick={() => file && onNext(file)} disabled={!file} data-id="element-53">
          Next Step <ArrowRight className="ml-2 h-4 w-4" data-id="element-54" />
        </Button>
      </div>
    </div>;
}